module.exports = __webpack_public_path__ + "img/w1.a985dd07.png";